export const DRILL_DOWN_COLUMN = {
  label: 0,
  soldCount: 1,
  stockCount: 2,
  soldPrice: 3,
  stockPrice: 4,
  soldMileage: 5,
  stockMileage: 6,
  difference: 7,
} as const;

export type DrillDownColumn = (typeof DRILL_DOWN_COLUMN)[keyof typeof DRILL_DOWN_COLUMN];
